import DashboardContent from '@/components/user/dashboard/content/content.vue'
import MobileMenu from '@/components/user/dashboard/mobile/mobile.vue'
import HeaderBar from '@/components/user/dashboard/header/header.vue'
import store from '@/services/store';
import ResourceSvc from '@/services/resource.svc.js';
const svc = new ResourceSvc();
import { EventBus } from '@/services/Event.js';

export default {
    components: {
        DashboardContent,
        MobileMenu,
        HeaderBar
    },
    data() {
        return {
            defaultClass: {
                'pl-3': true
            },
            userName: 'Site User',
            user: {
                details: {
                    createdDateString: null,
                    divisionString: null,
                    currentMembershipTypeName: null,
                    tiNumber: null,
                    fullname: null,
                    avatarSourseBase64: null,
                    fullName: 'Loading...',
                    juniorsIds: [],
                    clubsIds: [],
                    juniors:[]
                },
                clubs: {
                    mainClubCurrentYear: null, mainClubNextYear: null,
                    mainClubPaymentYear: { adultsAvailable: 0, adultsRegistered: 0, adultsTotal: 0 }
                },
                membership: { label: '', isNextYearMembership: false },
                menu: {
                    isAffilateClub: false,
                    isManageClubs: false,
                    isAccessRemoveClubUsers: false,

                    isManageRaces: false,
                    isRacesCopyList: false,
                    isRaceRegistrations: false,
                    isMakeRaceRequest: false,
                    IsRaceTransfer: false,
                    
                    isBuyODM: false,
                    isListODMs: false,

                    isAgeGroupSeriesApplication: false,
                    isViewAgeGroupSeriesApplications: false,
                    isSuperSeriesAthleteApplication: false,

                    isMemberCard: false,
                    isUpgrade: false,
                    isRenew: false
                }
            },
        }
    },
    computed: {
        isMenu() {
            return this.user && this.user.menu;
        },
        linkMembershipLabel() {            
            if (this.user.menu.isRenew && !this.user.menu.isUpgrade) { return 'Renew Membership' }
            else if (!this.user.menu.isRenew && this.user.menu.isUpgrade) { return 'Upgrade Membership' }
            else if (!this.user.menu.isRenew && !this.user.menu.isUpgrade) { return 'My Membership' }
        },
        //profile
        isAgeGroupApplicationVisible() {
            return this.isMenu && this.user.menu.isAgeGroupSeriesApplication;
        },
        isViewAgeGroupSeriesApplicationsVisible() {
            return this.isMenu && this.user.menu.isViewAgeGroupSeriesApplications;
        },
        isSuperSeriesAthleteApplicationVisible() {
            return this.isMenu && this.user.menu.isSuperSeriesAthleteApplication;
        },

        //my races
        isRaceRequestTopLevel() {
            return this.isMenu && !this.isRaceRegistrations && this.user.menu.isMakeRaceRequest;
        },
        isRaceRequestBottomLevel() {
            return this.isRaceRegistrations && this.user.menu.isMakeRaceRequest;
        },
        isRaceRegistrations() {
            return this.isMenu && this.user.menu.isRaceRegistrations;
        },
        isRaceTransfer() {
            return this.isMenu && this.user.menu.isRaceTransfer;
        },
        isAnyJuniorHasRaceTransfer() {
            return this.isMenu && this.user.menu.isAnyJuniorHasRaceTransfer;
        },
        isBuyOneDayMembershipVisibleTopLevel() {
            return this.isMenu && this.user.menu.isBuyODM && !this.user.menu.isListODMs;
        },
        isListODMsVisibleTopLevel() {
            return this.isMenu && this.user.menu.isListODMs && !this.user.menu.isBuyODM;
        },
        isOneDayMembershipVisible() {
            return this.isMenu && this.user.menu.isListODMs && this.user.menu.isBuyODM;
        },
        isUserIsOfficerVisible() {
            return this.isMenu && this.user.menu.isUserIsOfficerVisible;
        },
        //my races

        //club management
        isClubManagementVisible() {
            return this.isMenu && (this.user.menu.isManageClubs || this.user.menu.isAccessRemoveClubUsers);
        },
        isClubManagementLinkVisible() {
            return this.isMenu && this.user.menu.isManageClubs;
        },
        isAffilateClubVisibleTopLevel() {
            return this.isMenu && !this.isClubManagementVisible && this.user.menu.isAffilateClub;
        },
        isAffilateClubVisibleBottomLevel() {
            return this.isClubManagementVisible && this.user.menu.isAffilateClub;
        },
        isClubManagementRemovalVisible() {
            return this.isMenu && this.user.menu.isAccessRemoveClubUsers;
        },
        //club management

        //race management
        isRaceManagementVisible() {
            return this.isMenu && this.user.menu.isManageRaces;
        },
        isCreateRaceVisibleTopLevel() {
            return this.isMenu && !this.isRaceManagementVisible && this.user.menu.isMakeRaceRequest;
        },
        isCreateRaceVisibleBottomLevel() {
            return this.isRaceManagementVisible && this.user.menu.isMakeRaceRequest;
        },
        //race management

        //profile section
        wrapperClass() {
            return {
                wrapper: true,
                'nav-open': this.$sidebar.showSidebar
            };
        },
        //membership section
        isMemberDiscountsVisible() {
            return this.user &&
                this.user.menu &&
                this.user.menu.isMemberDiscountsVisible;
        },
        isVisibleJoinAdultToClub() {
            return this.user &&
                this.user.clubs &&
                this.user.clubs.mainClubPaymentYear &&
                this.user.clubs.mainClubPaymentYear.adultsAvailable;
        },
        isVisibleJoinedAdults() {
            return this.user &&
                this.user.clubs &&
                this.user.clubs.mainClubPaymentYear &&
                this.user.clubs.mainClubPaymentYear.adultsTotal &&
                !this.user.clubs.mainClubPaymentYear.adultsAvailable;
        },
        isMemberCardVisible() {
            return this.isMenu && this.user.menu.isMemberCard;
        },
        //juniors section
        isAddJuniorAccountVisibleOnTopLevel() {
            return this.user &&
                this.user.details &&
                this.user.details.juniorsIds &&
                this.user.details.juniorsIds.length == 0;
        },
        isAddJuniorAccountVisibleOnBottomLevel() {
            return this.user &&
                this.user.details;
        },
        isJuniorsVisible() {
            return this.user &&
                this.user.details &&
                this.user.details.juniorsIds.length > 0;
        }
    },
    methods: {
        toggleSidebar() {
            if (this.$sidebar.showSidebar) {
                this.$sidebar.displaySidebar(false)
            }
        },
        getData() {
            var self = this;
            self.isProcessing = true;
            svc.getProfilePrimaryInfo().then(response => {
                var allData = response.body;
                self.isProcessing = false;

                if (!allData) {
                    self.$showError("Something went wrong!");
                    return;
                }
                if (!allData.isSuccess) {
                    self.$showError(allData.message);
                    return;
                }
                else {
                    self.user = allData;

                    store.commit('setUserShortInfo', self.user);

                    self.$console();
                    self.$console("New user connected:");
                    self.$console({ LoggedUser: self.user });

                    EventBus.$emit("user-load-dashboard-card", 0);
                    EventBus.$emit("user-load-adult-join-club");

                    EventBus.$emit('view-race-ragistration-load-user');
                    EventBus.$emit("user-load-junior-race-registrations");
                    EventBus.$emit("user-load-junior-edit-profile");
                    EventBus.$emit("user-load-junior-upgrade-membership");
                    EventBus.$emit("user-load-membership-card");
                    EventBus.$emit("user-load-junior-one-day-membership-menu");
                    EventBus.$emit("user-update-subscribe-news", self.user);

                    self.setIsMemberDiscountsLocalStorage();
                }
            }, () => {
                self.$showError();
                self.$router.push({ path: '/' });
            });
        },
        getLink(name, path, icon) {
            return {name, path, icon};
        },
        getOldLink(name, oldPath, icon) {
            return { name, path: oldPath, icon, isOld: true };
        },
        getOldLinkDomain(name, oldPath, icon) {
            return { name, path: oldPath, icon, isOld: true, domainName: 'published' };
        },
        setIsMemberDiscountsLocalStorage() {
            var cookieName = 'isMemberDiscountsVisible';
            var cookieValue = this.isMemberDiscountsVisible;
            var domain = 'triathlonireland.com';
            var path = '/';
            var myDate = new Date();
            myDate.setMonth(myDate.getMonth() + 12);
            document.cookie = `${cookieName}=${cookieValue};${myDate};domain=${domain};path=${path}`;
        }
    },
    created() {
        var self = this;
        self.getData();
        EventBus.$off("load-dashboard-data");
        EventBus.$on("load-dashboard-data", () => { self.getData(); });
    }
}



// WEBPACK FOOTER //
// ./src/components/user/dashboard/dashboard-layout/dashboard-layout.js